import { Coordinates } from '../common/address';
import { StockLocationEntity } from '../common/entity';

export enum MobileStockLocationSessionStatus {
  active = 'active',
  completed = 'completed',
}

export class MobileStockLocationSession extends StockLocationEntity {
  coordinates!: Coordinates;
  status!: MobileStockLocationSessionStatus;

  constructor(obj: any) {
    if (!obj.companyId || !obj.stockLocationId) return;
    super(obj.companyId, obj.stockLocationId);
    Object.assign(this, obj);
  }
}
